<template>
    <div class="container-fluid py-2 my-2">
        <div class="col-sm-12 row align-items-center">
                <div class="d-flex align-items-center">
                    <span class="glued-right">
                        <i class="ico ico-calendar fs-normal dark m-0"></i>
                    </span>

                    <date-picker-new class=""
                        v-model="filters.dateRange"
                        :enableClear="false"
                        :range="true"
                        :showFromTo="false"
                        @input="filterChanged">
                    </date-picker-new>
                </div>
        </div>
    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'

import DatePickerNew from '@/tools/DatePicker'
import extendedVSelect from '@/extends/vue-select'

export default {
    mixins: [reservationsMixin],
    data() {
        return {
            selectedResource: null,
            datePickerShortcuts: [
                {
                    text: 'Next 7 Days',
                    start: new Date(),
                    end: new Date(Date.now() + 3600 * 1000 * 24 * 7)
                },
                {
                    text: 'Next 30 days',
                    start: new Date(),
                    end: new Date(Date.now() + 3600 * 1000 * 24 * 30)
                }
            ]
        }
    },
    props: {
        filters: {
            type: Object
        },
        availableResources: {
            type: Array,
            default: []
        },
        availableDurations: {
            type: Array,
            default: []
        }
    },
    computed: {
        editedResources() {
            if (this.availableResources) {
                // This JSON gymanstic so that the a bind is not created, otherwise the changes here will affect this.resources
                let resourcesEdited = JSON.parse(JSON.stringify(this.availableResources));

                resourcesEdited.unshift({
                    id: null,
                    name: 'All resources'
                });

                // Set default dropdown
                if (this.selectedResource == null) {
                    this.selectedResource = this.firstResourceWithAvailability();
                }

                return resourcesEdited;
            } else {
                return [];
            }
        },
        editedDurations() {
            if (this.availableDurations) {
                // This JSON gymanstic so that the a bind is not created, otherwise the changes here will affect this.resources
                let durationsEdited = JSON.parse(JSON.stringify(this.availableDurations));

                durationsEdited.unshift({
                    id: null,
                    name: 'All durations'
                });

                //set default dropdown
                if (this.filters.duration == null) {
                    this.filters.duration = durationsEdited[0];
                }

                return durationsEdited;
            } else {
                return [];
            }
        },
    },
    methods: {
        filterChanged() {
            this.$emit('filterChanged', this.filters);
        }
    },
    components: {
        DatePickerNew,
        vSelect: extendedVSelect
    }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// Filters.vue?d8991b6a